import React from "react"

export function ScheduleSection() {
  return (
    <div className="grid gap-8 md:grid-cols-2">
      <div className="md:col-span-2 space-y-6">
        <h2 className="text-2xl font-semibold">Schedule & Important Dates</h2>

        <div className="grid gap-4 md:grid-cols-2">
          <div className="rounded-lg border border-gray-400 p-4">
            <h3 className="font-medium">Conference</h3>
            <p className="text-sm text-muted-foreground">Dec’ 4–7, 2025 • Chandigarh, Punjab</p>
            <ul className="mt-2 text-sm text-muted-foreground grid gap-1">
              <li>• Plenary & Keynote Lectures</li>
              <li>• Technical Sessions</li>
              <li>• Workshops & Demos</li>
            </ul>
          </div>

          <div id="abstracts" className="rounded-lg border border-gray-400 p-4">
            <h3 className="font-medium">Abstracts</h3>
            <ul className="text-sm text-muted-foreground grid gap-1">
              <li>➢ 15 Aug ’25 — Open</li>
              <li>➢ 25 Sep ’25 — Close</li>
              <li>➢ 30 Sep ’25 — Acceptance</li>
              <li>➢ 30 Sep ’25 — Registration Start</li>
            </ul>
            <a
              href="http://www.iitrpr.ac.in/biomanthan/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex mt-3 rounded-md bg-primary text-primary-foreground px-3 py-2 text-xs font-medium hover:opacity-90 transition-opacity"
            >
              Submit & Register
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
